<template>
  <header class="header">
    <div class="header__text">
      <h1 class="header__title">Local League of Legends communities</h1>
      <p class="header__subtitle">Find out who's the highest ranked player anywhere in the world, how you rank against local players, or just find some new league friends who live nearby.</p>
      <router-link to="/add" class="tf-button mr10">
        Add your summoner
      </router-link>
    </div>
    <div class="header__image-wrapper">
      <img
        src="@/assets/images/PhaseRush.png"
        width="256"
        height="256"
        class="header__image"
        alt="unsealed spellbook"
      >
    </div>
  </header>
</template>

<script>
export default {
  name: 'Intro'
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  padding: 20px 0;
  align-items: center;
  justify-content: space-between;
  flex-direction: column-reverse;
  text-align: center;

  @media (min-width: 768px) {
    padding: 60px 0;
    flex-direction: row;
    text-align: left;
  }

  &__image-wrapper {
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }

  &__image {
    @media (max-width: 767px) {
      width: 70vw;
      height: auto;
    }
  }

  &__text {
    max-width: 700px;
  }

  &__title {
    font-size: 28px;
    margin-bottom: 15px;

    @media (min-width: 768px) {
      font-size: 36px;
    }
  }

  &__subtitle {
    font-size: 16px;
    margin-bottom: 25px;

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
}

.mr10 {
  margin-right: 10px;
  @media (max-width: 400px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>